import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37060756"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-address" }, "No properties available. Please contact your provider.", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_PropertyMenu = _resolveComponent("PropertyMenu")!
  const _component_MyAccountMenu = _resolveComponent("MyAccountMenu")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: _ctx.openDrawer,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openDrawer) = $event)),
    color: _ctx.bgColor,
    style: {"border":"none"},
    width: "205"
  }, {
    append: _withCtx(() => [
      _createVNode(_component_v_list, {
        "bg-color": _ctx.bgColor,
        class: "item-margin"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MyAccountMenu, null, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_list, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    class: "item-style",
                    link: ""
                  }, {
                    append: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('../assets/NavigationWebIcons/caret.svg')
                      }, null, 8, _hoisted_6)
                    ]),
                    prepend: _withCtx(() => [
                      _createElementVNode("img", {
                        style: {"margin-right":"10px"},
                        src: require('../assets/NavigationWebIcons/account.svg')
                      }, null, 8, _hoisted_7)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("My Account")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["bg-color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, { color: _ctx.bgColor }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "company-info" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                width: 50,
                class: "rounded-logo",
                src: _ctx.companyLogo
              }, null, 8, ["src"]),
              _createVNode(_component_v_tooltip, {
                text: _ctx.companyNameUpdates,
                bottom: ""
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _mergeProps({ class: "company-name" }, props), _toDisplayString(_ctx.companyNameUpdates), 17)
                ]),
                _: 1
              }, 8, ["text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(_component_v_list, {
        "bg-color": _ctx.bgColor,
        class: "margin-list"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PropertyMenu, {
            modelValue: _ctx.propertySelected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.propertySelected) = $event)),
            properties: _ctx.properties
          }, {
            emptyActivator: _withCtx(() => [
              _hoisted_1
            ]),
            activator: _withCtx(({ props, propertySelected, properties }) => [
              (properties.length == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_tooltip, {
                      text: _ctx.propertyName(propertySelected),
                      bottom: ""
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("div", _mergeProps({ class: "address" }, props), _toDisplayString(_ctx.propertyName(properties[0])), 17)
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ]))
                : (_openBlock(), _createBlock(_component_v_list, _mergeProps({ key: 1 }, props, { class: "margin-list" }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        class: "properties-border",
                        link: ""
                      }, {
                        append: _withCtx(() => [
                          _createElementVNode("img", {
                            src: require('../assets/NavigationWebIcons/caret.svg')
                          }, null, 8, _hoisted_3)
                        ]),
                        default: _withCtx(() => [
                          (_ctx.isAllSelected(propertySelected))
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("All Properties")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_v_tooltip, {
                                  text: _ctx.propertyName(propertySelected),
                                  bottom: ""
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_list_item_title, _normalizeProps(_guardReactiveProps(props)), {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.propertyName(propertySelected)), 1)
                                      ]),
                                      _: 2
                                    }, 1040)
                                  ]),
                                  _: 2
                                }, 1032, ["text"])
                              ]))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1040))
            ]),
            _: 1
          }, 8, ["modelValue", "properties"])
        ]),
        _: 1
      }, 8, ["bg-color"]),
      _createVNode(_component_v_list, {
        "bg-color": _ctx.bgColor,
        class: "margin-list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navSections, (section, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item-margin",
              key: index,
              link: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.links, (link) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: link.icon,
                  link: "",
                  onClick: ($event: any) => (_ctx.$router.push(link.path)),
                  disabled: _ctx.isDisabledLink(link),
                  value: link.name,
                  active: link.path === _ctx.$route.path,
                  "active-class": 'active-item',
                  ripple: false,
                  class: "item-style"
                }, {
                  prepend: _withCtx(({ isActive }) => [
                    _createElementVNode("img", {
                      src: isActive ? link.webIconPathActive : link.webIconPath
                    }, null, 8, _hoisted_5),
                    _createVNode(_component_v_list_item_title, {
                      class: _normalizeClass({ 'font-title': isActive }),
                      style: {"margin-left":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled", "value", "active"]))
              }), 128))
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["bg-color"])
    ]),
    _: 1
  }, 8, ["modelValue", "color"]))
}